import Moment from 'moment';
import { DateRange, extendMoment } from 'moment-range';

import { exceedsMaxDays } from './dateRangeValidation';

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
const moment = extendMoment(Moment as any);

export type RangeEndpoint = 'start' | 'end';

export type RollingSelection = { range: DateRange } | { date: Date; endpoint: RangeEndpoint; exceededLimit: true };

/** Keeps the most recent pick when it cannot form a range within the rolling window. */
export const resolveRollingRange = ({
  retainedDate,
  selectedDate,
  selectedEndpoint,
  maxDaysCount,
}: {
  retainedDate: Date;
  selectedDate: Date;
  selectedEndpoint?: RangeEndpoint;
  maxDaysCount: number;
}): RollingSelection => {
  const range = orderedRange(retainedDate, selectedDate);
  if (!exceedsMaxDays({ from: range.start, to: range.end, maxDaysCount })) return { range };

  return {
    date: startOfDay(selectedDate),
    endpoint: selectedEndpoint ?? (moment(selectedDate).isBefore(retainedDate, 'day') ? 'start' : 'end'),
    exceededLimit: true,
  };
};

const startOfDay = (date: Date) => moment(date).startOf('day').toDate();

const orderedRange = (a: Date, b: Date) => {
  const first = startOfDay(a);
  const second = startOfDay(b);

  return first <= second ? moment.range(moment(first), moment(second)) : moment.range(moment(second), moment(first));
};
